/* ============================================================
   Статичные данные, не зависящие от языка
   ============================================================ */

/**
 * Иконки услуг (порядок строго соответствует массиву `services`
 * в каждом словаре перевода — индекс i связывает их вместе).
 */
export const SERVICE_ICONS: readonly string[] = [
  "<path d='M3 9h18M9 21V9'/><rect x='3' y='4' width='18' height='17' rx='2'/>",
  "<circle cx='12' cy='12' r='9'/><path d='M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18'/>",
  "<rect x='4' y='4' width='6' height='6' rx='1'/><rect x='14' y='14' width='6' height='6' rx='1'/><path d='M7 10v4h10'/>",
  "<path d='M12 2 4 5v6c0 5 3.5 8 8 11 4.5-3 8-6 8-11V5z'/><path d='m9 12 2 2 4-4'/>",
  "<rect x='7' y='2' width='10' height='20' rx='2'/><path d='M11 18h2'/>",
  "<path d='m8 6-6 6 6 6M16 6l6 6-6 6'/>",
  "<path d='M5 13a10 10 0 0 1 14 0M8.5 16.5a5 5 0 0 1 7 0'/><circle cx='12' cy='20' r='1'/>",
  "<circle cx='12' cy='8' r='4'/><path d='M4 21a8 8 0 0 1 16 0'/>",
  "<path d='M12 2v4M12 18v4M2 12h4M18 12h4'/><circle cx='12' cy='12' r='4'/>",
];
